import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-800 text-white pt-12 pb-6" data-id="element-134">
      <div className="container mx-auto px-4" data-id="element-135">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-136">
          <div data-id="element-137">
            <Link to="/" className="flex items-center mb-4" data-id="element-138">
              <span className="text-blue-400 font-bold text-2xl" data-id="element-139">
                SafeCircuit
              </span>
              <span className="text-white font-semibold ml-1" data-id="element-140">EICR</span>
            </Link>
            <p className="text-gray-400 mb-4" data-id="element-141">
              Professional Electrical Installation Condition Reports across the
              UK. Ensuring safety and compliance for all property types.
            </p>
            <div className="flex space-x-4" data-id="element-142">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-143">
                <FacebookIcon size={20} data-id="element-144" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-145">
                <TwitterIcon size={20} data-id="element-146" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-147">
                <InstagramIcon size={20} data-id="element-148" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-149">
                <LinkedinIcon size={20} data-id="element-150" />
              </a>
            </div>
          </div>
          <div data-id="element-151">
            <h3 className="font-semibold text-lg mb-4" data-id="element-152">Our Services</h3>
            <ul className="space-y-2" data-id="element-153">
              <li data-id="element-154">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-155">
                  Residential EICR
                </a>
              </li>
              <li data-id="element-156">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-157">
                  Commercial EICR
                </a>
              </li>
              <li data-id="element-158">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-159">
                  Industrial EICR
                </a>
              </li>
              <li data-id="element-160">
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors" data-id="element-161">
                  Pricing
                </a>
              </li>
              <li data-id="element-162">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-163">
                  Book an Inspection
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-164">
            <h3 className="font-semibold text-lg mb-4" data-id="element-165">Useful Links</h3>
            <ul className="space-y-2" data-id="element-166">
              <li data-id="element-167">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-168">
                  About Us
                </a>
              </li>
              <li data-id="element-169">
                <a href="#faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-170">
                  FAQ
                </a>
              </li>
              <li data-id="element-171">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors" data-id="element-172">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors" data-id="element-174">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors" data-id="element-176">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-177">
            <h3 className="font-semibold text-lg mb-4" data-id="element-178">Contact</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-179">
              <li data-id="element-180">123 Electric Avenue</li>
              <li data-id="element-181">London, EC1A 1BB</li>
              <li data-id="element-182">United Kingdom</li>
              <li className="pt-2" data-id="element-183">
                <a href="tel:+441234567890" className="hover:text-white transition-colors" data-id="element-184">
                  01234 567890
                </a>
              </li>
              <li data-id="element-185">
                <a href="mailto:info@safecircuit-eicr.co.uk" className="hover:text-white transition-colors" data-id="element-186">
                  info@safecircuit-eicr.co.uk
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 mt-6 text-sm text-gray-400" data-id="element-187">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-188">
            <p data-id="element-189">© {currentYear} SafeCircuit EICR. All rights reserved.</p>
            <div className="mt-4 md:mt-0" data-id="element-190">
              <ul className="flex space-x-4" data-id="element-191">
                <li data-id="element-192">
                  <Link to="/terms" className="hover:text-white transition-colors" data-id="element-193">
                    Terms
                  </Link>
                </li>
                <li data-id="element-194">
                  <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-195">
                    Privacy
                  </Link>
                </li>
                <li data-id="element-196">
                  <Link to="/cookies" className="hover:text-white transition-colors" data-id="element-197">
                    Cookies
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;